import { ENUM__local_event } from '@/services/events/ENUM__local_event';
import { service_local_events } from '@/services/events/service_local_events';
import { store } from '@/state/store';
import { local_workspace_billing_balance_upsert } from '@/state/workspace/billing/local_workspace_billing_balance_upsert';
import { local_workspace_billing_credits_transactions_upsert } from '@/state/workspace/billing/local_workspace_billing_credits_transactions_upsert';
import { local_workspace_billing_payment_transactions_upsert } from '@/state/workspace/billing/local_workspace_billing_payment_transactions_upsert';
import { local_billing_workspace_subscriptions_upsert } from '@/state/workspace/billing/local_workspace_billing_subscriptions_upsert';
import { DTOWorkspaceBalance } from '@shared/dto/+workspace/workspace_balance/dto_workspace_balance';
import { DTOWorkspaceCreditTransaction } from '@shared/dto/+workspace/workspace_credit_transaction/dto_workspace_credit_transaction';
import { DTOworkspacePaymentTransactionStripe } from '@shared/dto/+workspace/workspace_payment_transaction.ts/dto_workspace_payment_transaction_stripe';
import { DTOWorkspaceSubscription } from '@shared/dto/+workspace/workspace_subscription/dto_workspace_subscription';
import { ENUM__network_event_server_to_client as ENE } from '@shared/network/ENUM__network_event_server_to_client';
import { add_socket_handler_client as add } from '../../_methods/add_socket_handler_client';

export function add_socket_handlers_client_workspace_billing() {
  add(ENE.WORKSPACE_SUBSCRIPTIONS_UPSERT, (items: DTOWorkspaceSubscription[]) => store.dispatch(local_billing_workspace_subscriptions_upsert(items)));

  add(ENE.WORKSPACE_BILLING_CREDITS_TRANSACTIONS_UPSERT, (items: DTOWorkspaceCreditTransaction[]) =>
    store.dispatch(local_workspace_billing_credits_transactions_upsert(items)),
  );
  add(ENE.WORKSPACE_BILLING_PAYMENT_TRANSACTIONS_UPSERT, (items: DTOworkspacePaymentTransactionStripe[]) =>
    store.dispatch(local_workspace_billing_payment_transactions_upsert(items)),
  );

  add(ENE.WORKSPACE_BILLING_BALANCE_UPSERT, (items: DTOWorkspaceBalance[]) => store.dispatch(local_workspace_billing_balance_upsert(items)));

  add(ENE.WORKSPACE_BILLING_LOW_BALANCE, (_: any) => service_local_events.emit(ENUM__local_event.RESPONSE_LOW_BALANCE_RECEIVED));
}
